import Lo from "lodash";

export function removeDeprecatedOptions(item, itemsStates, loops) {
    let initialState;
    if (item.loopName) {
        const loop = loops[item.loopName];
        initialState = loop.states[loop.index - 1][item.id];
    } else {
        initialState = itemsStates[item.id];
    }
    // we need here to process the values to remove deprecated dropdown options
    if (initialState !== undefined && initialState.values !== undefined) {
        for (let i = 0; i < item.fields.length; i++) {
            const field = item.fields[i];
            if (field.type === 'dropdown' && !field.allowAdditions) {
                // we have to remove the values that are not valid options
                const uniqueOptionsValues = new Set();
                if (field.options) {
                    field.options.map((option) => (
                        uniqueOptionsValues.add(option.value)
                    ));
                }
                let newValues;
                let oldValues = initialState.values[i];
                if (oldValues === undefined) {
                    continue;
                }
                if (field.multiple) {
                    if (!Array.isArray(oldValues)) {
                        oldValues = [oldValues];
                    }
                    newValues = Array();
                    for (let j = 0; j < oldValues.length; j++) {
                        const value = oldValues[j];
                        if (uniqueOptionsValues.has(value)) {
                            newValues.push(value);
                        }
                    }
                } else if (uniqueOptionsValues.has(oldValues)) {
                    newValues = oldValues;
                }
                initialState.values[i] = newValues;
            }
        }
    }
}

export function fieldsChanged(previousState, newFields) {
    if (!previousState) {
        return true;
    } else {
        const previousFields = previousState.fields;
        if (previousFields === newFields) {
            return false;
        }
        const obviousCaseChanged = previousFields === undefined
            || previousFields === null || newFields === undefined || newFields === null
            || previousFields.length !== newFields.length;
        if (obviousCaseChanged) {
            return obviousCaseChanged;
        }
        for (let i = 0; i < previousFields.length; i++) {
            if (previousFields[i].label !== newFields[i].label) {
                return true;
            }
        }
        return false;


    }
}

export function getShortLoopName(loopName) {
    let shortName = loopName.substring(loopName.lastIndexOf(LOOPS_COMPONENTS_SEPARATOR) + 1);
    if (shortName === undefined) {
        shortName = loopName;
    }
    shortName = shortName.substring(0, shortName.lastIndexOf('$')) || shortName;
    return shortName;
}

export function getAllLoopsName(loopName) {
    return loopName.split(LOOPS_COMPONENTS_SEPARATOR)
}

const LOOPS_INDEX_SEPARATOR = '$';
export const LOOPS_COMPONENTS_SEPARATOR = "#";

export function getParentLoopName(loopName) {
    const index = loopName.indexOf(LOOPS_COMPONENTS_SEPARATOR);
    if (index === -1) {
        return loopName;
    }
    return loopName.substring(0, index);
}

function findInPath(state, itemId, group) {
    for (let i = 0; i < state.path.length; i++) {
        if (state.path[i].itemId === itemId && state.path[i].group === group) {
            return i;
        }
    }
    return -1;
}

export function buildPath(state, currentItemId, currentGroup, nextItemId, loopName, nextGroup) {
    const pos = findInPath(state, currentItemId, currentGroup);
    const posExisting = findInPath(state, nextItemId, nextGroup);
    let path = [...state.path];
    if (posExisting !== -1) {
        path.splice(posExisting + 1);
        let loop = null;
        // we update the metadata associated to this pathItem
        // to point to the last loop index
        if (loopName) {
            const loopState = state.loops[loopName];
            const loopIndex = loopState ? loopState.index : 1;
            loop = {loopName, loopIndex, group: nextGroup};
        }
        path[posExisting].loop = loop;
        path[posExisting].group = nextGroup;
    } else {
        path.splice(pos + 1);
        let loop = null;
        if (loopName) {
            const loopState = state.loops[loopName];
            const loopIndex = loopState ? loopState.index : 1;
            loop = {loopName, loopIndex, group: nextGroup};
        }
        path.push({
            itemId: nextItemId,
            loop,
            group: nextGroup
        });
    }
    return path;
}